angular.module("vgresiduos").controller("SupplierDashboardCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `fornecedor/visao-geral`, getQueries());
		};

		function getQueries() {
			const queries = [];
			if ($stateParams.tab) {
				queries.push({ key: "tab", value: $stateParams.tab });
			}
			if ($stateParams.utmSource) {
				queries.push({ key: "utmSource", value: $stateParams.utmSource });
			}
			if ($stateParams.abrirPainel) {
				queries.push({ key: "abrirPainel", value: $stateParams.abrirPainel });
			}
			return queries;
		}
	}
]);
